// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Go-z","imageAndVideoCount":"Ho-z","imageAndVideoContainer":"Io-z","viewAllReviews":"Jo-z"};